import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Input } from 'rizzui';
import CustomSelect from '../../../../../components/forms/CustomSelect';
import useOrderTypes from "../../../../../hooks/api-calls/orders/useOrderTypes";
import useFetch from '../../../../../hooks/useFetch';
import FormGroup from '../../../../../layout/shared/form-group';
import { OrderService } from "../../../../../services/order/orderService";
import { OrderApiResponse } from "../../../../../type/entities/order-type";
import OrderProfileLayout from "../../OrderProfileLayout";

const OrderInfo = () => {

    const { id = '' } = useParams<{ id: string }>();
    const { getOrderTypesList } = useOrderTypes();

    const [data] = useFetch(useCallback(async () => {
        if (!id || id === '') return null;
        const response = await (new OrderService()).getOrderById(id);
        return response.getResponseData() as OrderApiResponse;
    }, [id]));

    return (
        <OrderProfileLayout>
            <div className="@container">
                <div className="grid grid-cols-12 gap-5 2xl:h-[75vh]">
                    <div className="col-span-12 overflow-y-auto h-full">
                        <FormGroup
                            title="Información General"
                            description="Datos asociados al pedido."
                            titleCols="@md:col-span-2"
                            childCols="@md:col-span-10 md:grid-cols-4"
                        >
                            <CustomSelect
                                readOnly
                                id={'orderTypeId'}
                                label="Tipo de Pedido"
                                value={getOrderTypesList()?.find((g: any) => g.value === data?.orderTypes?.id)}
                                containerClassName='col-span-12 md:col-span-4'
                            />

                            <Input
                                readOnly
                                id='startDate'
                                type="date"
                                className="col-span-12 md:col-span-2"
                                label="Fecha de inicio"
                                value={data?.startDate?.date.split(' ')[0]}
                            />

                            <Input
                                readOnly
                                id='endDate'
                                type="date"
                                className="col-span-12 md:col-span-2"
                                label="Fecha de fin"
                                value={data?.endDate?.date.split(' ')[0]}
                            />

                            <Input
                                readOnly
                                id='collectionDate'
                                type="date"
                                className="col-span-12 md:col-span-2"
                                label="Fecha de cobro"
                                value={data?.collectionDate?.date.split(' ')[0]}
                            />

                            <Input
                                readOnly
                                id='orderDate'
                                type="date"
                                className="col-span-12 md:col-span-2"
                                label="Fecha de pedido"
                                value={data?.orderDate?.date.split(' ')[0]}
                            />

                            <Input
                                readOnly
                                id='calendarDays'
                                className="col-span-12 md:col-span-2"
                                label="Dias naturales"
                                value={data?.calendarDays}
                            />

                            <Input
                                readOnly
                                id='workingDays'
                                className="col-span-12 md:col-span-2"
                                label="Dias laborables"
                                value={data?.workingDays}
                            />

                            {data?.lastOrderKoReason && (
                                <>
                                    <Input
                                        readOnly
                                        id='lastOrderKoReasonName'
                                        className="col-span-12 md:col-span-4"
                                        label="Motivo de KO"
                                        value={data.lastOrderKoReason.name}
                                    />
                                    <Input
                                        readOnly
                                        id='lastOrderKoReasonDescription'
                                        className="col-span-12 md:col-span-8"
                                        label="Descripción del motivo de KO"
                                        value={data.lastOrderKoReason.description ?? ''}
                                    />
                                </>
                            )}
                        </FormGroup>
                    </div>
                </div>

            </div>
        </OrderProfileLayout>
    );
};

export default OrderInfo;